export default __webpack_public_path__ + "static/media/acura.255a833e.svg";